// extracted by mini-css-extract-plugin
export var dropdownButton = "_4f-0";
export var fullWidthDropdownButton = "_4f-1";
export var icon = "_4f-3";
export var iconPlaceholder = "_4f-2";
export var menuItemRow = "_4f-9";
export var separator = "_4f-e";
export var shortcutContainer = "_4f-7";
export var shortcutContainerFilled = "_4f-8";
export var shortcutIconLg = "_4f-6";
export var shortcutIconMd = "_4f-5";
export var shortcutIconSm = "_4f-4";
export var submenuChevron = "_4f-d";
export var submenuDropdown = "_4f-a";
export var submenuTriggerRow = "_4f-b";
export var submenuTriggerRowOpen = "_4f-c";